import { Descriptions } from "antd";
import type { DescriptionsProps } from "antd";

import useItems from "./helpers/useItems";
import type { Investment, ReadInvestment } from "../../../types";

const LABEL_STYLE = { width: "30%" };

type Props = {
  investment: Investment;
  readInvestment: ReadInvestment;
};

const FundingDescriptions = ({ investment, readInvestment }: Props) => {
  const items = useItems(investment, readInvestment);

  const descriptionsProps: DescriptionsProps = {
    size: "small",
    column: 1,
    bordered: true,
    className: "compact black",
    labelStyle: LABEL_STYLE,
    items,
  };

  return (
    <Descriptions {...descriptionsProps} />
  );
};

export default FundingDescriptions;
